export default "__VITE_ASSET__D3_zJCmD__"